// Where to go after signing in: kept in sessionStorage across the round trip to Keycloak.
const RETURN_TO_KEY = 'xped.returnTo';

export function rememberReturnTo(path: string) {
  try {
    sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    // Storage unavailable: the user lands on Plan.
  }
}

/** The page the user asked for before signing in, or Plan (the map) by default. Read once. */
export function takeReturnTo(): string {
  let returnTo: string | null = null;
  try {
    returnTo = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
  } catch {
    // Storage unavailable: go to the default.
  }
  return returnTo && returnTo !== '/' && !returnTo.startsWith('/auth/') ? returnTo : '/plan';
}
